<fieldset main-item class="fieldset-forms">
  <legend *ngIf="label" [id]="labelId">{{ label }}
    <span *ngIf="require" class="text-danger" aria-hidden="true">*</span>
  </legend>
  <textarea
    #child
    #field="ngModel"
    [id]="inputId"
    class="form-control border-0 bg-transparent shadow-none p-0"
    [readOnly]="readonly"
    [(ngModel)]="inputValue"
    [placeholder]="placeholder? placeholder: label"
    [disabled]="disable"
    [required]="require"
    [pattern]="pattern"
    [attr.aria-labelledby]="label ? labelId : null"
    [attr.aria-required]="require ? 'true' : null"
    [attr.aria-invalid]="errorShown ? 'true' : null"
    [attr.aria-describedby]="describedByIds"
    (blur)="errorState.schedule()">
  </textarea>
</fieldset>
<div *ngIf="helperText" [id]="helperId" class="form-text uc-helper-text">{{ helperText }}</div>
<div item-alert aria-live="polite">
  <div *ngIf="errorShown" [id]="errorId" role="alert" class="alert alert-danger my-1 py-1">
    <div *ngIf="field.errors?.required">{{ 'validation.required' | translate }}</div>
    <div *ngIf="field.errors?.pattern">{{ patternError? patternError : 'validation.pattern' | translate }}</div>
  </div>
</div>
